import { render, staticRenderFns } from "./diagnosisExpert.vue?vue&type=template&id=4827e4d2&scoped=true"
import script from "./diagnosisExpert.vue?vue&type=script&lang=js"
export * from "./diagnosisExpert.vue?vue&type=script&lang=js"
import style0 from "./diagnosisExpert.vue?vue&type=style&index=0&id=4827e4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827e4d2",
  null
  
)

export default component.exports